import { createSlice } from "@reduxjs/toolkit";

const debounceSelectFiltersSlice = createSlice({
  name: "debounceSelectFilters",
  initialState: {
    machine_class: null,
    machine_type: null,
    location: null,
    search_item: null,
    plant_id: null,
    quant_unit: null,
    asset_status: null,
    select_all: false,
  },
  reducers: {
    set_debounceSelectFilters: (state, action) => {
      return action.payload;
    },
  },
});

export const { set_debounceSelectFilters } = debounceSelectFiltersSlice.actions;
export default debounceSelectFiltersSlice.reducer;
